import { NAME_SPACES, useTranslationNameSpace } from 'i18n/hooks';
import { GetInTouchSection } from 'modules/sections/components';
import { TabsSection } from 'modules/sections/components/TabsSection/TabsSection';
import {
  COLORS,
  FlexColumn,
  FlexRow,
  TEXT_SIZES,
  TEXT_TYPES,
  TEXT_WEIGHTS,
  Text,
  FlotableElement,
  Square,
} from 'modules/ui/components';
import { ANIMATIONS_TYPES } from 'modules/ui/components/Animatable';
import { PageTitle } from 'modules/ui/components/PageTitle';
import { subCards, tabs } from './utils';
import { Animatable } from 'modules/ui/components/Animatable';
import { useMediaQuery } from 'react-responsive';

export const DesktopMediaPlatform = () => {
  const { t } = useTranslationNameSpace(NAME_SPACES.PAGES);

  const isTablet = useMediaQuery({
    query: `(max-width: ${900}px)`,
  });

  const isBigTablet = useMediaQuery({
    query: `(max-width: ${1130}px)`,
  });

  return (
    <FlexColumn w="100%" h="100%">
      <PageTitle title={t('mediaPlatform.title')} />
      <FlexColumn
        w="100%"
        alignItems="center"
        position="relative"
        bgSize="cover"
        bg="url(./assets/backgrounds/background-4.png)"
      >
        <FlexColumn w="80%" alignItems="center">
          <FlexColumn w="100%" alignItems="center">
            <Text
              m="70px 0 26px 0"
              size="35px"
              type={TEXT_TYPES.title}
              color={COLORS.lightBlue}
              weight={TEXT_WEIGHTS.bolder}
              letterSpacing="1.4px"
              lineHeight="35px"
              whiteSpace="pre-wrap"
              textAlign="center"
            >
              {t('mediaPlatform.cards.0.title')}
            </Text>
            <Text
              w="70%"
              size="25px"
              type={TEXT_TYPES.text}
              color={COLORS.white}
              weight={TEXT_WEIGHTS.tiny}
              textAlign="center"
              whiteSpace="pre-wrap"
              letterSpacing="0.88px"
              lineHeight="30px"
            >
              {t('mediaPlatform.cards.0.text')}
            </Text>
          </FlexColumn>
          <FlexRow m="100px 0">
            <img src="./assets/media-platform/card-0.png" alt="platform" />
          </FlexRow>
          <FlexColumn
            w="100%"
            m="40px 0 0 0"
            alignItems="center"
            justifyContent="center"
          >
            <Animatable animationType={ANIMATIONS_TYPES.appendBottom}>
              <FlexColumn w="100%" alignItems="center">
                <Text
                  size="35px"
                  type={TEXT_TYPES.title}
                  color={COLORS.lightBlue}
                  weight={TEXT_WEIGHTS.bolder}
                  letterSpacing="1.4px"
                  lineHeight="35px"
                  textAlign="center"
                >
                  {t('mediaPlatform.cards.1.title')}
                </Text>
                <Text
                  size="22px"
                  type={TEXT_TYPES.text}
                  color={COLORS.white}
                  weight={TEXT_WEIGHTS.tiny}
                  whiteSpace="pre-wrap"
                  letterSpacing="0.62px"
                  lineHeight="30px"
                  textAlign="center"
                >
                  {t('mediaPlatform.cards.1.text')}
                </Text>
              </FlexColumn>
            </Animatable>
          </FlexColumn>
          <FlexRow
            m="50px 0"
            w="100%"
            justifyContent="space-between"
            flexWrap="wrap"
          >
            {subCards.map((_, i) => (
              <FlexColumn
                w={isBigTablet ? '90%' : '30%'}
                alignItems="center"
                justifyContent={!isBigTablet ? 'flex-start' : 'center'}
                m="50px 25px"
              >
                <FlexColumn w="100%" alignItems="center" h="100px">
                  <img
                    src={`./assets/media-platform/subCard-${i}.png`}
                    alt="sub-card"
                  />
                </FlexColumn>

                <FlexColumn m="20px 0" h="100px" justifyContent="flex-end">
                  <Text
                    m="30px 0 10px 0"
                    size="30px"
                    letterSpacing="1.4px"
                    type={TEXT_TYPES.title}
                    color={COLORS.lightBlue}
                    weight={TEXT_WEIGHTS.bolder}
                    whiteSpace="pre-wrap"
                    textAlign="center"
                  >
                    {t(`mediaPlatform.subCards.${i}.title`)}
                  </Text>
                </FlexColumn>
                <Text
                  w="80%"
                  size={TEXT_SIZES.s}
                  type={TEXT_TYPES.text}
                  color={COLORS.white}
                  weight={TEXT_WEIGHTS.tiny}
                  textAlign="center"
                  letterSpacing="0.56px"
                  lineHeight="30px"
                  whiteSpace="pre-wrap"
                >
                  {t(`mediaPlatform.subCards.${i}.text`)}
                </Text>
              </FlexColumn>
            ))}
          </FlexRow>
          <FlexRow
            m="70px 0"
            w="80%"
            h="auto"
            gap={!isTablet ? '100px' : '50px'}
            flexDirection={isTablet ? 'column !important' : 'row'}
            alignItems="center"
            justifyContent="space-between"
          >
            <img src="./assets/media-platform/card-1.png" alt="platform" />
            <FlexColumn w="auto">
              <Animatable animationType={ANIMATIONS_TYPES.appendBottom}>
                <FlexColumn w="100%" alignItems="center">
                  <Text
                    size="35px"
                    type={TEXT_TYPES.title}
                    color={COLORS.lightBlue}
                    weight={TEXT_WEIGHTS.bolder}
                    letterSpacing="1.4px"
                    lineHeight="35px"
                    textAlign="center"
                  >
                    {t('mediaPlatform.cards.1.title')}
                  </Text>
                  <Text
                    size="22px"
                    type={TEXT_TYPES.text}
                    color={COLORS.white}
                    weight={TEXT_WEIGHTS.tiny}
                    whiteSpace="pre-wrap"
                    letterSpacing="0.88px"
                    lineHeight="30px"
                    textAlign="center"
                  >
                    {t('mediaPlatform.cards.1.text')}
                  </Text>
                </FlexColumn>
              </Animatable>
            </FlexColumn>
          </FlexRow>
        </FlexColumn>
        <FlexColumn
          w="100%"
          p="120px 0 50px 0"
          alignItems="center"
          justifyContent="center"
          bg={`linear-gradient(180deg, ${COLORS.darkBlue}, rgba(79, 255, 255, 0.1))`}
        >
          <TabsSection
            tabsPadding="0 10px"
            tabsFontSize="20px"
            tabsHeight="48px"
            tabs={tabs.map((_, i) => ({
              title: t(`mediaPlatform.tabs.${i}.title`),
              content: (
                <FlexRow
                  flexDirection={isBigTablet ? 'column !important' : 'row'}
                  w="80%"
                  alignItems="center"
                  gap={!isBigTablet ? '70px' : '20px'}
                >
                  <img
                    src={`./assets/media-platform/tab-${i}.png`}
                    alt="title"
                  />
                  <FlexColumn
                    w="70%"
                    h={!isBigTablet ? '600px' : 'auto'}
                    justifyContent={isBigTablet ? 'start' : 'center'}
                    alignItems="center"
                  >
                    <Text
                      m="20px 0"
                      size="32px"
                      type={TEXT_TYPES.text}
                      color={COLORS.lightBlue}
                      weight={TEXT_WEIGHTS.bolder}
                      letterSpacing="1.128px"
                      lineHeight="35px"
                      whiteSpace="pre-wrap"
                    >
                      {t(`mediaPlatform.tabs.${i}.subTitle`)}
                    </Text>
                    <Text
                      size="22px"
                      type={TEXT_TYPES.text}
                      color={COLORS.white}
                      weight={TEXT_WEIGHTS.tiny}
                      letterSpacing="0.78px"
                      lineHeight="25px"
                      whiteSpace="pre-wrap"
                    >
                      {t(`mediaPlatform.tabs.${i}.text`)}
                    </Text>
                  </FlexColumn>
                </FlexRow>
              ),
            }))}
          />
        </FlexColumn>
        <GetInTouchSection title={t(`tv.contactSection.title`) as string} />
        <FlotableElement left="87%" top="-3%">
          <Square zIndex="1" size="30vw" />
        </FlotableElement>
        <FlotableElement left="-20%" top="5%">
          <Square zIndex="1" size="30vw" />
        </FlotableElement>
      </FlexColumn>
    </FlexColumn>
  );
};
